import ApplicationController from './application_controller'
import { get_csrf_token } from '../app/csrf_token.js'

// IMPORTANT NOTE: Turbo.renderStreamMessage(html) throws errors on turbo-frames.
// This must return a turbo-stream to work correctly.
//
// Consider using turbo-form if you need to update an entire frame, otherwise you
// must parse the html response, pull out the frame from the response and replace the element
// by it's turbo-frame#identifier selector.
export default class extends ApplicationController {

	static targets = [
		'input',
	]

	static values = {
		path: String,
	}

	update(_event) {
		const formData = new FormData()
		formData.append('authenticity_token', get_csrf_token())

		this.inputTargets.forEach((input) => {
			const name = this.getInputName(input)
			const value = this.getInputValue(input)
			formData.append(name, value)
		})

		fetch(this.pathValue, {
			method: 'POST',
			body: formData,
		})
		.then(r => r.text())
		.then((html) => {
			Turbo.renderStreamMessage(html)
		})
	}

	getInputName(input) {
		if ('streamableName' in input.dataset) {
			return input.dataset.streamableName
		} else {
			return input.name
		}
	}

	getInputValue(input) { return input.value }

}
